<template>

<div class="vertical_center">
<div class=" p-4 shadow-2 border-round w-full ">
    <div class="text-center mb-5">
        
        <div class="text-900 text-3xl font-medium mb-3">{{$store.state.languages.lang_phrases.hosgeldiniz}}</div>

        <div class="text-900 text-1xl font-medium mb-3">{{$store.state.languages.lang_phrases.lütfen_yeni_sifrenizi_girin_ve_onaylayin}}</div>
        <!--<span class="text-600 font-medium line-height-3">Don't have an account?</span>
        <a class="font-medium no-underline ml-2 text-blue-500 cursor-pointer">Create today!</a>-->
    </div>

    <div>
        

      <span class="p-float-label mb-5">
        <InputText id="password" type="password" v-model="password" class="w-full p-inputtext-lg"  :class="{'p-invalid':errors.passerror }" v-on:keyup.enter="submit"/>
        <label for="password">{{$store.state.languages.lang_phrases.sifre}}</label>
        <small  class="p-error pt-2" v-if="errors.passerror"> {{errors.passerror_message}}</small>
      </span>
      <span class="p-float-label mb-5">
        <InputText id="repassword" type="password" v-model="repassword" class="w-full p-inputtext-lg" :class="{'p-invalid':errors.repasserror }" v-on:keyup.enter="submit"/>
        <label for="repassword">{{$store.state.languages.lang_phrases.sifre_tekrar}}</label>
        <small  class="p-error pt-2" v-if="errors.repasserror"> {{errors.repasserror_message}}</small>
      </span>
   

       

        

        <Button :label="$store.state.languages.lang_phrases.sifreyi_onayla" icon="pi pi-user" class="w-full p-button-primary" :loading="$store.state.ui.submitting" @click="submit"></Button>
         <div class="flex align-items-center justify-content-end mt-6">           
            <router-link to="/login" class="font-medium no-underline ml-2 text-blue-500 text-right cursor-pointer">{{$store.state.languages.lang_phrases.ya_da_giris_yapin}}</router-link>
        </div>
    </div>
</div>
</div>





</template>

<script>
export default {

  name: 'ResetPassword',

  data () {
    return {
      checked:false,
      repassword:null,
      password:null,
      errors:{
        passerror:false,
        passerror_message:null,
        repasserror:false,
        repasserror_message:null
      }
    }
  },
  mounted()
  {
    this.checkToken()
  },
  methods:{
    async checkToken()
    {
      let user = await this.generalApiGet("check_reset_link/"+this.$route.params.token)
      console.log("user");
      console.log(user);
      if(user=="no records")
      {
        this.$router.push({ name: 'Login'})
      }
    },
    submit()
    {
      this.errors = {
        passerror:false,
        passerror_message:null,
        repasserror:false,
        repasserror_message:null
      }
      if(!this.password)
      {
        this.errors.passerror = true
        this.errors.passerror_message = "Lütfen bu alanı doldurun"
        return false

      }

      if(this.password.length<8)
      {
        this.errors.passerror = true
        this.errors.passerror_message = "Şifreniz en az 8 karakter uzunluğunda olmalı"
        return false
      }


      if(!this.repassword)
      {
        this.errors.repasserror = true
        this.errors.repasserror_message = "Lütfen bu alanı doldurun"
        return false
      }
      if(this.password !== this.repassword)
      {
        this.errors.repasserror = true
        this.errors.repasserror_message = "2. şifre ilk şifre ile uyuşmuyor"
        return false
      }   
      let userLang = navigator.language || navigator.userLanguage;
      
      userLang = userLang.slice(0, 2);
      console.log(userLang);
      let formdata = new FormData()
      formdata.append("password",this.password)
      formdata.append("preflang",this.userLang)
      formdata.append("reset_string",this.$route.params.token)
      this.generalSubmission(formdata,"reset_password",this.afterSubmit)
    },
    afterSubmit(response)
    {

      console.log(response.data);
      if(response.data=="ok")
      {
        this.$router.push({ name: 'Login'})
      }
    }
  },
};
</script>

<style lang="css" scoped>
</style>